import React from "react";

const ProductDimension = ({ register, errors, countDimension, disabled }) => {
  return (
    <div className="card-footer" style={{ borderRadius: 10 }}>
      <div className="row">
        <div className="col-md-12">
          <h6>Product Dimension</h6>
          <div className="dropdown-divider" />
          <div className="row">
            <div className="col-md-2">
              <span>
                Height (mm){" "}
                {errors.height && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.height.message}
                  </span>
                )}
              </span>
              <input
                id="height"
                {...register("height", {
                  required: { value: true, message: "is required!" },
                  min: { value: 0.01, message: "must be > 0" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Height (mm)"
                className="form-control"
                disabled={disabled}
              />
            </div>

            <div className="col-md-2">
              <span>
                Width (mm){" "}
                {errors.width && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.width.message}
                  </span>
                )}
              </span>
              <input
                id="width"
                {...register("width", {
                  required: { value: true, message: "is required!" },
                  min: { value: 0.01, message: "must be > 0" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Width (mm)"
                className="form-control"
                disabled={disabled}
              />
            </div>

            <div className="col-md-2">
              <span>
                Length (mm){" "}
                {errors.length && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.length.message}
                  </span>
                )}
              </span>
              <input
                id="length"
                {...register("length", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Length (mm)"
                className="form-control"
                disabled={disabled}
              />
            </div>

            <div className="col-md-2">
              <span>
                Depth (mm){" "}
                {errors.depth && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.depth.message}
                  </span>
                )}
              </span>
              <input
                id="depth"
                {...register("depth", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Depth (mm)"
                className="form-control"
                disabled={disabled}
              />
            </div>

            <div className="col-md-2">
              <span>
                Volume (kgv){" "}
                {errors.volume && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.volume.message}
                  </span>
                )}
              </span>
              <input
                id="volume"
                {...register("volume", {
                  required: { value: true, message: "is required!" },
                  min: { value: 0.01, message: "must be > 0" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Volume (kgv)"
                className="form-control"
                disabled={disabled}
              />
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-md-2">
              <span>
                Thickness (mm){" "}
                {errors.thickness && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.thickness.message}
                  </span>
                )}
              </span>
              <input
                id="thickness"
                {...register("thickness", {
                  required: { value: true, message: "is required!" },
                  min: { value: 0, message: "must be > 0" },
                })}
                type="text"
                placeholder="Thickness (mm)"
                className="form-control"
                disabled={disabled}
              />
            </div>

            <div className="col-md-2">
              <span>
                Weight{" "}
                {errors.weight && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.weight.message}
                  </span>
                )}
              </span>
              <input
                id="weight"
                {...register("weight", {
                  required: { value: true, message: "is required!" },
                  min: { value: 0.01, message: "must be > 0" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Weight (kg)"
                className="form-control"
                disabled={disabled}
              />
            </div>

            <div className="col-md-2">
              <span>
                Weight Unit{" "}
                {errors.weight_type && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.weight_type.message}
                  </span>
                )}
              </span>
              <select
                id="weight_type"
                className="form-control"
                {...register("weight_type", {
                  required: { value: true, message: "is required!" },
                })}
                disabled={disabled}
              >
                <option value="">Select Weight Type</option>
                <option value="GR">Gram</option>
                <option value="KG">KG</option>
              </select>
            </div>
          </div>
        </div>

        <div className="col-md-12 mt-3">
          <h6>Package Dimension</h6>
          <div className="dropdown-divider" />
          <div className="row">
            <div className="col-md-2">
              <span>
                Outer Height (mm){" "}
                {errors.outer_height && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.outer_height.message}
                  </span>
                )}
              </span>
              <input
                id="outer_height"
                {...register("outer_height", {
                  required: { value: true, message: "is required!" },
                  min: { value: 0.01, message: "must be > 0" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Outer Height (mm)"
                className="form-control"
                disabled={disabled}
              />
            </div>

            <div className="col-md-2">
              <span>
                Outer Width (mm){" "}
                {errors.outer_width && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.outer_width.message}
                  </span>
                )}
              </span>
              <input
                id="outer_width"
                {...register("outer_width", {
                  required: { value: true, message: "is required!" },
                  min: { value: 0.01, message: "must be > 0" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Outer Width (mm)"
                className="form-control"
                disabled={disabled}
              />
            </div>

            <div className="col-md-2">
              <span>
                Outer Length (mm){" "}
                {errors.outer_length && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.outer_length.message}
                  </span>
                )}
              </span>
              <input
                id="outer_length"
                disabled={disabled}
                {...register("outer_length", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Outer Length (mm)"
                className="form-control"
              />
            </div>

            <div className="col-md-2">
              <span>
                Outer Depth (mm){" "}
                {errors.outer_depth && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.outer_depth.message}
                  </span>
                )}
              </span>
              <input
                id="outer_depth"
                disabled={disabled}
                {...register("outer_depth", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Outer Depth (mm)"
                className="form-control"
              />
            </div>

            <div className="col-md-2">
              <span>
                Outer Weight (kg){" "}
                {errors.outer_weight && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.outer_weight.message}
                  </span>
                )}
              </span>
              <input
                id="outer_weight"
                disabled={disabled}
                {...register("outer_weight", {
                  required: { value: true, message: "is required!" },
                  min: { value: 0.01, message: "must be > 0" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Outer Weight (kg)"
                className="form-control"
              />
            </div>
          </div>
        </div>

        <div className="col-md-12 mt-3">
          <h6>Cut Out Dimension</h6>
          <div className="dropdown-divider" />
          <div className="row">
            <div className="col-md-2">
              <span>
                Height (mm){" "}
                {errors.cut_out_height && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.cut_out_height.message}
                  </span>
                )}
              </span>
              <input
                id="cut_out_height"
                disabled={disabled}
                {...register("cut_out_height", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Cut Out Height (mm)"
                className="form-control"
              />
            </div>

            <div className="col-md-2">
              <span>
                Width (mm){" "}
                {errors.cut_out_width && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.cut_out_width.message}
                  </span>
                )}
              </span>
              <input
                id="cut_out_width"
                disabled={disabled}
                {...register("cut_out_width", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Cut Out Width (mm)"
                className="form-control"
              />
            </div>

            <div className="col-md-2">
              <span>
                Length (mm){" "}
                {errors.cut_out_length && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.cut_out_length.message}
                  </span>
                )}
              </span>
              <input
                id="cut_out_length"
                disabled={disabled}
                {...register("cut_out_length", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Cut Out Length (mm)"
                className="form-control"
              />
            </div>

            <div className="col-md-2">
              <span>
                Depth (mm){" "}
                {errors.cut_out_depth && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.cut_out_depth.message}
                  </span>
                )}
              </span>
              <input
                id="cut_out_depth"
                disabled={disabled}
                {...register("cut_out_depth", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Cut Out Depth (mm)"
                className="form-control"
              />
            </div>
          </div>
        </div>

        <div className="col-md-12 mt-3">
          <h6>Topmount Cut Out Dimension</h6>
          <div className="dropdown-divider" />
          <div className="row">
            <div className="col-md-2">
              <span>
                Height (mm){" "}
                {errors.cut_out_height_topmount && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.cut_out_height_topmount.message}
                  </span>
                )}
              </span>
              <input
                id="cut_out_height_topmount"
                disabled={disabled}
                {...register("cut_out_height_topmount", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Topmount Cut Out Height (mm)"
                className="form-control"
              />
            </div>

            <div className="col-md-2">
              <span>
                Width (mm){" "}
                {errors.cut_out_width_topmount && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.cut_out_width_topmount.message}
                  </span>
                )}
              </span>
              <input
                id="cut_out_width_topmount"
                disabled={disabled}
                {...register("cut_out_width_topmount", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Topmount Cut Out Width (mm)"
                className="form-control"
              />
            </div>

            <div className="col-md-2">
              <span>
                Length (mm){" "}
                {errors.cut_out_length_topmount && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.cut_out_length_topmount.message}
                  </span>
                )}
              </span>
              <input
                id="cut_out_length_topmount"
                disabled={disabled}
                {...register("cut_out_length_topmount", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Topmount Cut Out Length (mm)"
                className="form-control"
              />
            </div>
          </div>
        </div>

        <div className="col-md-12 mt-3">
          <h6>Undermount Cut Out Dimension</h6>
          <div className="dropdown-divider" />
          <div className="row">
            <div className="col-md-2">
              <span>
                Height (mm){" "}
                {errors.cut_out_height_undermount && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.cut_out_height_undermount.message}
                  </span>
                )}
              </span>
              <input
                id="cut_out_height_undermount"
                disabled={disabled}
                {...register("cut_out_height_undermount", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Undermount Cut Out Height (mm)"
                className="form-control"
              />
            </div>

            <div className="col-md-2">
              <span>
                Width (mm){" "}
                {errors.cut_out_width_undermount && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.cut_out_width_undermount.message}
                  </span>
                )}
              </span>
              <input
                id="cut_out_width_undermount"
                disabled={disabled}
                {...register("cut_out_width_undermount", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Undermount Cut Out Width (mm)"
                className="form-control"
              />
            </div>

            <div className="col-md-2">
              <span>
                Length (mm){" "}
                {errors.cut_out_length_undermount && (
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    {errors.cut_out_length_undermount.message}
                  </span>
                )}
              </span>
              <input
                id="cut_out_length_undermount"
                disabled={disabled}
                {...register("cut_out_length_undermount", {
                  required: { value: true, message: "is required!" },
                  onChange: countDimension,
                })}
                type="text"
                placeholder="Undermount Cut Out Length (mm)"
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDimension;
